@use '@/styles/variables' as *;

.toast {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: $z-toast;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  max-width: 380px;
  padding: 0.875rem 1rem;
  border-radius: var(--radius);
  background: color-mix(in oklch, var(--destructive) 14%, white);
  border: 1px solid color-mix(in oklch, var(--destructive) 45%, white);

  :global(.dark) & {
    background: color-mix(in oklch, var(--destructive) 20%, black);
    border-color: color-mix(in oklch, var(--destructive) 50%, black);
  }
  box-shadow: var(--shadow-soft);
  animation: slideUp 0.2s ease-out;

  @media (max-width: #{$breakpoint-xs}) {
    right: 1rem;
    left: 1rem;
    max-width: none;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message {
  flex: 1;
  font-size: 0.875rem;
  color: var(--card-foreground);
  line-height: 1.5;
}

.dismiss {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.125rem;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted-foreground);
  transition: color 0.15s;

  &:hover {
    color: var(--card-foreground);
  }
}
